module.exports = __webpack_public_path__ + "img/xls.e75c2d36.svg";